import React, { useState, useEffect, useRef } from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import axios from "axios";
import { useHistory } from "react-router-dom";
import CircularProgress from '@material-ui/core/CircularProgress';

if (!localStorage.getItem('locale')) {
    localStorage.setItem('locale', 'en');
}

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            SUNeVision
            {' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        opacity: '88%',
        'border-radius': '5px'
    },
    companyLogo: {
        height: 80,
        margin: theme.spacing(3),
    },
    mainGrid: {
        paddingTop: '15vh',
        height: '30vh',
    },
    image: {
        backgroundImage: 'url(images/login.png)',
        backgroundRepeat: 'no-repeat',
        backgroundColor:
            theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    },
    paper: {
        backgroundColor: '#FFF',
        padding: theme.spacing(4, 4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative',
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    Video: {
        width: '100%',
        height: '100%',
        position: 'fixed',
        'z-index': '-10',
        'background-color': '#000',
        'filter': 'blur(5px)',
        '-webkit-filter': 'blur(5px)'
    }
}));

export default function SignInSide(props) {
    const classes = useStyles();
    const [username, setUserName] = useState();
    const [password, setPassword] = useState();
    const [loading, setLoading] = React.useState(false);
    const isMounted = useRef(null);
    const history = useHistory();
    const videoSource = "videos/Office Background Video HD.mp4";

    useEffect(() => {
        localStorage.removeItem('employee_name');
        localStorage.removeItem('token');
        localStorage.removeItem('staff_duty');
        localStorage.removeItem('selectedIndex');
        localStorage.removeItem('isApplicationOpen');
        localStorage.removeItem('isMyRequestOpen');
        localStorage.removeItem('isLeaveApprovalOpen');
        localStorage.removeItem('isHRAdminOpen');
        localStorage.removeItem('isHrAdminRole');
        localStorage.removeItem('department_id');
    }, []);

    useEffect(() => {
        // executed when component mounted
        isMounted.current = true;
        return () => {
            // executed when unmount
            isMounted.current = false;
        }
    }, []);

    const handleSubmit = async e => {
        e.preventDefault();
        setLoading(true);
        // get backend access token
        axios.get(process.env.REACT_APP_API_URL + "/sanctum/csrf-cookie").then(
            (response) => {
                // LOGIN
                axios
                    .post(process.env.REACT_APP_API_URL + "/api/login",
                        { username: username, password: password }
                    )
                    .then(
                        (response) => {
                            localStorage['token'] = response.data.token;

                            // default destination
                            if (props.location.state === undefined) {
                                history.push("/home");
                            } else {
                                // redirect to destination after login
                                history.push(props.location.state.from.pathname);
                            }
                        },
                        // LOGIN ERROR
                        (error) => {
                            console.error(error);
                            localStorage.removeItem('employee_name');
                            localStorage.removeItem('token');
                            alert('The login username maybe wrong, please check.');
                        }
                    ).finally(() => {
                        if (isMounted.current) {
                            setLoading(false);
                        }
                    });

            },
            // COOKIE ERROR
            (error) => {
                console.error(error);
                alert('Cannot get the token');
            });

    }

    return (
        <div>
            <video autoPlay loop muted playsInline className={classes.Video}>
                <source src={videoSource} type="video/mp4" />
                Your browser does not support the video tag.
            </video>

            <Container component="main" maxWidth="xs">
                <div className={classes.root}>
                    <Grid container className={classes.mainGrid}>
                        <CssBaseline />
                        <Grid item xs={12} sm={12} md={12} component={Paper} elevation={6} square>
                            <div className={classes.paper}>
                                <img src="images/Logo_of_SUNeVision.png" className={classes.companyLogo} />
                                <Typography component="h1" variant="h5">
                                    {process.env.REACT_APP_TITLE}
                                </Typography>
                                <form className={classes.form} onSubmit={handleSubmit} noValidate>
                                    <TextField
                                        variant="outlined"
                                        margin="normal"
                                        required
                                        fullWidth
                                        id="username"
                                        label="Username"
                                        name="username"
                                        autoComplete="username"
                                        autoFocus
                                        onChange={e => setUserName(e.target.value)}
                                    />
                                    <TextField
                                        variant="outlined"
                                        margin="normal"
                                        required
                                        fullWidth
                                        name="password"
                                        label="Password"
                                        type="password"
                                        id="password"
                                        autoComplete="current-password"
                                        onChange={e => setPassword(e.target.value)}
                                    />
                                    <div className={classes.wrapper}>
                                        <Button
                                            type="submit"
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            className={classes.submit}
                                            disabled={loading}
                                        >
                                            Sign In
                                        </Button>
                                        {loading &&
                                            <CircularProgress size={24} className={classes.buttonProgress} />}
                                    </div>
                                    <Box mt={5}>
                                        <Copyright />
                                    </Box>
                                </form>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </Container>
        </div>
    )

}